import { Component } from '@angular/core';

import { AppLauncherStateService } from '../app-launcher-state.service';

@Component({
	selector: 'sd-limit-modal',
	templateUrl: './limit-modal.component.html',
})
export class LimitModalComponent {
	constructor(public readonly state: AppLauncherStateService) {}

	public remove(): void {
		this.state.removeDeployment();
	}

	public requestAccess(): void {
		this.state.goTo('painted');
	}
}
